var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"dark":""}},[(_vm.loggedIn)?_c('TheHeader'):_vm._e(),_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1),_c('TheFooter')],1),_c('TheToast'),_c('TheConfirm'),_c('TheModal'),_c('TheMaintenance')],1)}
var staticRenderFns = []

export { render, staticRenderFns }